module.exports = __webpack_public_path__ + "img/3-3.332feb0b.svg";